import { Machine, assign } from 'xstate';

interface PaymentMachineContext {
  cardValidated: boolean;
  termsAccepted: boolean;
  retryCount: number;
}

const setCardToValid = assign((context: PaymentMachineContext) => ({
  ...context,
  cardValidated: true,
}));

const setCardToInvalid = assign((context: PaymentMachineContext) => ({
  ...context,
  cardValidated: false,
}));

const setTermsAccepted = assign((context : PaymentMachineContext) => ({
  ...context,
  termsAccepted: true,
}));

const setTermsRefused = assign((context : PaymentMachineContext) => ({
  ...context,
  termsAccepted: false,
}));

function transactionReady(context : PaymentMachineContext) {
  return context.cardValidated && context.termsAccepted;
}

export default Machine({
  id: 'payment',
  initial: 'idle',
  context: {
    cardValidated: false,
    termsAccepted: false,
    retryCount: 0,

  },
  states: {
    idle: {
      on: {
        READY: {
          target: 'ready',
          cond: 'transactionReady',
        },
        ACCEPTED: {
          actions: 'setTermsAccepted',
        },
        REFUSED: {
          actions: 'setTermsRefused',
        },
        CARD_VALID: {
          actions: 'setCardToValid',
        },
        CARD_INVALID: {
          actions: 'setCardToInvalid',
        },
      },
    },
    ready: {
      on: {
        START: {
          target: 'transactionPending',
          cond: 'transactionReady',
        },
        REFUSED: {
          target: 'idle',
          actions: 'setTermsRefused',
        },
        CARD_INVALID: {
          target: 'idle',
          actions: 'setCardInvalid',
        },
      },
    },
    transactionPending: {
      on: {
        RESOLVE: 'schedulePending',
        REJECT: 'transactionFail',
      },
    },
    transactionFail: {
      on: {
        DUPLICATE: 'schedulePending',
        DECLINED: {
          target: 'idle',
          actions: [
            'setCardToInvalid',
          ],
        },
        ERROR: {
          target: 'idle',
          actions: 'setCardToInvalid',
        },

      },
    },

    schedulePending: {
      on: {
        SUCCESS: 'scheduleSuccess',
        REJECT: 'scheduleFail',
        ERROR: 'scheduleFail',
      },
    },
    scheduleFail: {
      on: {

        RETRY: 'schedulePending',
        ERROR: {
          target: 'idle',
          actions: setCardToInvalid,

        },
      },
    },
    scheduleSuccess: {
      type: 'final',
    },

  },
}, {
  actions: {
    setCardToValid,
    setCardToInvalid,
    setTermsAccepted,
    setTermsRefused,
  },
  guards: {
    transactionReady,
  },
});
